<template>
  <el-container :class="$store.state.sceneClassName">
    <el-header height="auto">
      <v-h5-header v-if="$store.state.sceneClassName === 'app'"></v-h5-header>
      <v-header v-else></v-header>
    </el-header>
    <el-main>
      <router-view></router-view>
    </el-main>
    <el-footer>
      <v-footer></v-footer>
    </el-footer>
  </el-container>
</template>

<script>
import Consult from '@/components/Consult';
import Footer from '@/components/Footer';
import Header from '@/components/Header.vue';
import H5Header from '@/components/H5Header.vue';
export default {
  name: 'App',
  components: {
    'v-header': Header,
    'v-footer': Footer,
    'v-h5-header': H5Header,
    'v-consult': Consult
  },
  data() {
    return {};
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.setNavClassName(this.$route.name);
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iPad|Mobile)/i)) {
      this.$store.commit('toggleSceneClassName', 'app');
      this.compatibleH5();
    } else {
      this.$store.commit('toggleSceneClassName', '');
    }
  },
  methods: {
    compatibleH5() {
      var htmlDom = document.documentElement;
      var windowWidth = htmlDom.clientWidth;
      var evt = 'onorientationchange' in window ? 'orientationchange' : 'resize';
      htmlDom.style.fontSize = windowWidth / 7.5 + 'px';

      document.addEventListener('DOMContentLoaded', function () {
        if (!htmlDom.style.fontSize) {
          var htmlDomProtect = document.documentElement;
          var windowWidth = htmlDomProtect.clientWidth;
          htmlDomProtect.style.fontSize = windowWidth / 7.5 + 'px';
        }
      }, false);

      window.addEventListener(evt, function () {
        setTimeout(function () {
          var htmlDomProtect = document.documentElement;
          var windowWidth = htmlDomProtect.clientWidth;
          htmlDomProtect.style.fontSize = windowWidth / 7.5 + 'px';
        }, 200);
      }, false);
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.setNavClassName(this.$route.name, scrollTop);
    },
    setNavClassName(routeName, scrollTop = 0) {
      let name = '';
      if (routeName !== 'home' || (routeName === 'home' && scrollTop > 72)) {
        name = 'whiteNav';
      }
      this.$store.commit('toggleHeaderClassName', name);
      if (document.getElementById('mNav')) {
        let mName = 'mNav-transparent';
        if (routeName !== 'home' || (routeName === 'home' && scrollTop > document.getElementById('mNav').style.height)) {
          mName = '';
        }
        this.$store.commit('toggleH5HeaderClassName', mName);
      }
    }
  },
  watch: {
    $route(to, from) {
      this.setNavClassName(to.name);
    }
  }
};
</script>

<style lang='scss'>
.el-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .el-footer {
    height: auto !important;
    padding: 0;
  }
  &:not(.app) {
    min-width: 1200px;
  }
}
</style>
